import { n as c } from "./property-9daa16cd.mjs";
import { i as x, E as b, x as r, a as i, r as k } from "./createReactComponent-58f9bea8.mjs";
import { e as g } from "./class-map-2994e95e.mjs";
import { r as v } from "./icon-c572aa57.mjs";
const p = x`
  :host {
    display: block;
  }

  :host .checkbox__target-area {
    display: flex;
    border-radius: var(--exo-spacing-2x-small);
    width: calc(var(--exo-size-1) * 0.4);
    height: calc(var(--exo-size-1) * 0.4);
  }

  /* Focus Selected */
  :host .checkbox.checkbox--checked:focus-visible,
  :host .checkbox.checkbox--indeterminate:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
    border-radius: var(--exo-spacing-2x-small);
  }

  /* Hover Selected */
  :host .checkbox.checkbox--checked:focus-visible .checkbox__target-area,
  :host .checkbox.checkbox--checked .checkbox__target-area:hover,
  :host .checkbox.checkbox--indeterminate:focus-visible .checkbox__target-area,
  :host .checkbox.checkbox--indeterminate .checkbox__target-area:hover,
  :host .checkbox:hover.checkbox--checked .checkbox__target-area,
  :host .checkbox:hover.checkbox--indeterminate .checkbox__target-area {
    background: var(--exo-color-background-action-secondary-hover);
  }

  :host .checkbox.checkbox--checked:focus-visible .checkbox__control,
  :host .checkbox.checkbox--checked:hover .checkbox__control {
    background: var(--exo-color-background-selected-hover);
    border-color: var(--exo-color-background-selected-hover);
  }

  :host .checkbox:focus-visible .checkbox__target-area,
  :host .checkbox .checkbox__target-area:hover,
  :host .checkbox:hover .checkbox__target-area {
    background: var(--exo-color-background-action-hover-weak);
  }

  /* Checkbox Wrapper */
  :host .checkbox {
    box-sizing: border-box;
    font-family: var(--exo-font-family);
    font-size: var(--exo-font-size-small);
    font-weight: var(--exo-font-weight-regular);
    line-height: var(--exo-line-height-denser);
    color: var(--exo-color-font);
    display: inline-flex;
    gap: var(--exo-spacing-3x-small);
    cursor: pointer;
    vertical-align: middle;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Adding position relative to label if fixPositionIssue property is passed */
  :host .fix-position-issue {
    position: relative;
  }

  /* Checkbox Input Element */
  :host .checkbox__input {
    position: absolute;
    opacity: var(--exo-spacing-none);
    padding: var(--exo-spacing-none);
    margin: var(--exo-spacing-none);
    pointer-events: none;
  }
  :host .checkbox--disabled {
    pointer-events: none;
    cursor: not-allowed;
    color: var(--exo-color-font-disabled);
  }

  :host .checkbox__label {
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-2x-small)
      var(--exo-spacing-2x-small) var(--exo-spacing-none);
    color: var(--exo-color-font);
    width: fit-content;
    margin-top: var(--exo-spacing-4x-small);
  }

  :host .checkbox.checkbox--disabled .checkbox__control {
    background-color: var(--exo-color-background);
  }

  /* Checkbox Disabled State */
  :host .checkbox--checked.checkbox--disabled .checkbox__control,
  :host .checkbox--indeterminate.checkbox--disabled .checkbox__control,
  :host .checkbox--disabled .checkbox__control {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-disabled);
    background-color: var(--exo-color-background-disabled);
    stroke: var(--exo-color-background);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Checkbox Control Element */
  :host .checkbox__control {
    flex: 0 0 auto;
    align-self: flex-start;
    margin-left: calc(var(--exo-spacing-x-small) + var(--exo-spacing-4x-small));
    margin-top: calc(var(--exo-spacing-x-small) + var(--exo-spacing-4x-small));
    width: var(--exo-spacing-small);
    height: var(--exo-spacing-small);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-deselected);
    border-radius: var(--exo-radius-small);
    background-color: var(--exo-color-background);
  }

  /* Checkbox Checked State */
  :host .checkbox--checked .checkbox__control,
  :host .checkbox--indeterminate .checkbox__control {
    border-color: var(--exo-color-background-selected);
    background-color: var(--exo-color-background-selected);
    stroke: var(--exo-color-icon-inverse);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* checkbox unchecked state #/
  :host .checkbox--indeterminate .checkbox__control {
    border-color: var(--exo-palette-black);
    stroke: var(--exo-color-icon-inverse);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Focus Unselected */
  :host .checkbox:focus-visible {
    border-radius: var(--exo-spacing-2x-small);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  /* Hover Unselected */
  :host .checkbox:focus-visible .checkbox__input,
  :host .checkbox .checkbox__input:hover {
    background: var(--exo-color-background-action-hover-weak);
  }

  /* Hover Selected */
  :host .checkbox--checked:focus-visible .checkbox__input,
  :host .checkbox.checkbox--checked .checkbox__input:hover {
    background: var(--exo-color-background-action-secondary-hover);
  }

  :host .help-text {
    display: flex;
    gap: var(--exo-spacing-2x-small);
    padding-left: calc(
      var(--exo-spacing-x-large) + var(--exo-spacing-3x-small)
    );
    font: var(--exo-text-label-micro);
  }

  /* Checkbox Footer Type */

  :host .checkbox__footer-info {
    color: var(--exo-color-background-info-strong);
  }

  :host .checkbox__footer-success {
    color: var(--exo-color-background-success-strong);
  }

  :host .checkbox__footer-error {
    color: var(--exo-color-background-danger-strong);
  }

  :host .checkbox__footer-warning {
    color: var(--exo-color-background-warning-strong);
  }

  /* Checkbox Size */

  :host .checkbox--size-small {
    max-width: var(--exo-size-2);
  }

  :host .checkbox--size-medium {
    max-width: var(--exo-size-4);
  }

  :host .checkbox--size-large {
    max-width: var(--exo-size-5);
  }

  /* Invalid state */
  :host .checkbox.invalid .checkbox__control {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .checkbox.checkbox--checked.checkbox.invalid .checkbox__control,
  .checkbox.checkbox--indeterminate.invalid .checkbox__control {
    border-color: var(--exo-color-background-danger-strong);
    background-color: var(--exo-color-background-danger-strong);
    stroke: var(--exo-color-icon-inverse);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :host .checkbox.invalid:hover .checkbox__target-area,
  .checkbox.invalid:hover .checkbox__control {
    background-color: var(--exo-color-background-danger-weak);
  }

  :host .checkbox.invalid:focus-visible {
    border-radius: var(--exo-spacing-2x-small);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host
    .checkbox.checkbox--checked
    .checkbox.invalid:hover
    .checkbox__target-area {
    background-color: var(--exo-color-background-danger-weak);
  }

  :host
    .checkbox.invalid.checkbox--indeterminate:focus-visible
    .checkbox__control {
    background-color: var(--exo-color-background-danger-strong);
  }

  :host .checkbox.invalid:focus-visible .checkbox__target-area,
  .checkbox.invalid:focus-visible .checkbox__control {
    background-color: var(--exo-color-background-danger-weak);
  }

  :host .checkbox.invalid.checkbox--indeterminate:hover .checkbox__control {
    background-color: var(--exo-color-background-danger-strong);
  }
`;
var u = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, t = (e, a, l, n) => {
  for (var h, s = n > 1 ? void 0 : n ? _(a, l) : a, d = e.length - 1; d >= 0; d--)
    (h = e[d]) && (s = (n ? h(a, l, s) : h(s)) || s);
  return n && s && u(a, l, s), s;
}, m = ((e) => (e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e.WARNING = "warning", e))(m || {}), f = ((e) => (e.MEDIUM = "medium", e.SMALL = "small", e.LARGE = "large", e))(f || {});
class o extends b {
  constructor() {
    super(...arguments), this.checked = !1, this.invalid = !1, this.indeterminate = !1, this.disabled = !1, this.disabledChecked = !1, this.disabledIndeterminate = !1, this.helpText = "", this.controlled = !1, this.footerType = "info", this.showStatusIcon = !1, this.fixPositionIssue = !1, this.statusIconLabel = "", this.size = "large";
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListeners();
  }
  handleClick() {
    this.controlled ? this.controlled && this.dispatchEvent(new CustomEvent("on-change", { detail: { checked: this.checked, value: this.value } })) : (this.checked = !this.checked, this.indeterminate = !1, this.dispatchEvent(new CustomEvent("on-change", { detail: { checked: this.checked, value: this.value } })));
  }
  getHelpText() {
    return this.helpText ? r`<span class="help-text"
        >${this.setStatusIcon()}${this.helpText}</span
      >` : i;
  }
  setStatusIcon() {
    if (this.invalid)
      return r`<ex-icon
        size="XS"
        icon="Error"
        label=${this.statusIconLabel}
      ></ex-icon>`;
    if (this.showStatusIcon)
      switch (this.footerType) {
        case "success":
          return r`<ex-icon
            size="XS"
            icon="Success"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        case "error":
          return r`<ex-icon
            size="XS"
            icon="Error"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        case "warning":
          return r`<ex-icon
            size="XS"
            icon="Warning"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        default:
          return r`<ex-icon
            size="XS"
            icon="Information"
            label=${this.statusIconLabel}
          ></ex-icon>`;
      }
    return i;
  }
  getIndeterminate() {
    return !this.checked && this.indeterminate ? r`
        <svg
          class="checkbox__icon"
          width="8"
          height="2"
          viewBox="0 0 8 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 1H1" stroke-linecap="square" stroke-linejoin="round" />
        </svg>
      ` : i;
  }
  getChecked() {
    return this.checked ? r`
        <svg
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 1L3.66667 7L1 4"
            stroke-linecap="square"
            stroke-linejoin="round"
          />
        </svg>
      ` : i;
  }
  handleKeyup(a) {
    a.code === "Space" && this.handleClick();
  }
  addEventListeners() {
    this.addEventListener("keyup", this.handleKeyup);
  }
  disabledCheck() {
    return this.disabledChecked ? r`
        <svg
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 1L3.66667 7L1 4"
            stroke-linecap="square"
            stroke-linejoin="round"
          />
        </svg>
      ` : i;
  }
  getDisabledIndeterminate() {
    return !this.checked && this.disabledIndeterminate ? r`
        <svg
          class="checkbox__icon"
          width="8"
          height="2"
          viewBox="0 0 8 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 1H1" stroke-linecap="square" stroke-linejoin="round" />
        </svg>
      ` : i;
  }
  renderFooter() {
    const a = this.invalid ? "error" : `${this.footerType}`;
    return r`
      <span class="checkbox__footer-${a}">
        ${this.getHelpText()}
      </span>
    `;
  }
  render() {
    return r` <div
      part="checkbox-parent"
      class="checkbox--size-${this.size}"
    >
      <label
        part="checkbox"
        class=${g({ checkbox: !0, invalid: this.invalid, "fix-position-issue": this.fixPositionIssue, "checkbox--checked": this.checked, "checkbox--indeterminate": this.indeterminate, "checkbox--disabled": this.disabled })}
        tabindex=${this.disabled ? "-1" : "0"}
      >
        <input
          type="checkbox"
          class="checkbox__input"
          name=${this.name}
          value=${this.value}
          .checked=${this.checked}
          aria-checked=${this.checked.toString()}
          @click=${this.handleClick}
          .indeterminate=${this.indeterminate}
          tabindex="-1"
        />
        <span part="checkbox-control" class="checkbox__target-area">
          <span class="checkbox__control">
            ${this.getChecked()} ${this.disabledCheck()}
            ${this.getDisabledIndeterminate()} ${this.getIndeterminate()}
          </span>
        </span>
        <span part="checkbox-label" class="checkbox__label">
          <slot></slot>
        </span>
      </label>
      ${this.renderFooter()}
    </div>`;
  }
}
o.styles = p, t([c()], o.prototype, "name", 2), t([c()], o.prototype, "value", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "checked", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "invalid", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "indeterminate", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "disabled", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "disabledChecked", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "disabledIndeterminate", 2), t([c({ attribute: "help-text" })], o.prototype, "helpText", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "controlled", 2), t([c()], o.prototype, "footerType", 2), t([c({ type: Boolean, reflect: !0 })], o.prototype, "showStatusIcon", 2), t([c({ type: Boolean, reflect: !0, attribute: "fix-position-issue" })], o.prototype, "fixPositionIssue", 2), t([c({ type: String })], o.prototype, "statusIconLabel", 2), t([c()], o.prototype, "size", 2);
const S = (e = "") => {
  k("ex-checkbox", o, e), v(e);
};
export {
  m as C,
  f as a,
  o as b,
  S as r
};
